module.exports = __webpack_public_path__ + "static/media/tcc_logo.a5204a89.svg";